"use client";

import React from "react";
import { ArrowRight, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BridgeTheGap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="bridge-the-gap" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32 lg:py-40">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-muted/30 pointer-events-none" />

      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-[0.03] pointer-events-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577832/img/eu_india_flags_watermark.png" alt="EU and India Flags Watermark" className="w-full h-full object-cover max-w-none sm:max-w-7xl" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight mb-10 max-w-4xl text-primary-foreground drop-shadow-sm">
          Ready to Expand Your Horizon?
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto bg-secondary text-secondary-foreground hover:bg-secondary/90 h-14 px-8 text-base font-semibold shadow-lg shadow-secondary/20 transition-all hover:scale-105">
            <Link to="#">
              Register as Supplier
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-semibold border-2 border-border bg-transparent text-primary-foreground hover:bg-accent hover:text-accent-foreground transition-all hover:scale-105">
            <Link to="#">
              <Building2 className="mr-2 size-5" />
              Register as Buyer
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}